module.exports = __webpack_public_path__ + "static/img/stack-of-jam.dfbcd95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stack-of-jam.jpg
// module id = 7odt
// module chunks = 1